export interface ScreenOption {
  id: string;
  title: string;
  previewTitle?: string;
  selected: boolean;
  includeErrorState?: boolean;
}

/**
 * List of all possible additional screens that can be included in PDF export
 * Based on the actual mockups and requirements
 */
export const DEFAULT_ADDITIONAL_SCREENS: ScreenOption[] = [
  // TODO: Uncomment screens as they are implemented
  {
    id: 'sms-auto-responses-screen',
    title: 'SMS Auto Responses (Help, Stop, Unrecognized & Custom)',
    previewTitle: 'SMS Auto Responses',
    selected: false,
  },
  {
    id: 'feed-view-disclaimer-screen',
    title: 'Feed View Disclaimer',
    previewTitle: 'Feed Disclaimer',
    selected: false,
  },
  {
    id: 'about-menu-items-screen',
    title: 'About Menu Items (About Relay, Terms & Conditions, Privacy Policy)',
    previewTitle: 'About Menu Items',
    selected: false,
  },
  {
    id: 'verification-screen',
    title: 'Verification Page',
    previewTitle: 'Verification Page',
    selected: false,
    includeErrorState: false,
  },
  {
    id: 'password-pages-screen',
    title: 'Password Pages (Create, Log In, Change, Forgot)',
    previewTitle: 'Password Pages',
    selected: false,
    includeErrorState: false,
  },
  //   {
  //     id: 'sign-up-screen',
  //     title: 'Sign-Up Page',
  //     previewTitle: 'Sign Up',
  //     selected: false,
  //     includeErrorState: false,
  //   },
];
